module.exports = __webpack_public_path__ + "static/media/google.de615292.png";